import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../_services';

import * as dayjs from 'dayjs';

@Component({
  templateUrl: './user-blocking.component.html',
  styleUrls: ['../auth.component.less']},
)

export class UserBlockingComponent implements OnInit {

  minutesTillBlockingFinish: string;
  timeBlockingFinish: string;
  constructor(
    private router: Router,
    private auth: AuthenticationService,
    private ngZone: NgZone
  ) {
  }
  ngOnInit() {
    const dateBlockingFinishString = localStorage.getItem('dateBlockingFinish');
    if (dateBlockingFinishString === null || Number(dateBlockingFinishString) <= (Date.now())){
      this.router.navigate(['/auth/login']);
    } else {
      const dateBlockingFinish = dayjs(Number(dateBlockingFinishString));
      const now = dayjs();
      this.setMinutesTillBlockingFinish(dateBlockingFinish, now);
      this.timeBlockingFinish = dateBlockingFinish.format('HH:mm');
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          localStorage.removeItem('dateBlockingFinish');
          this.auth.authClear();
          this.router.navigate(['/auth/login']);
        }, dateBlockingFinish.valueOf() - now.valueOf());
      });
    }
  }
  setMinutesTillBlockingFinish(dateBlockingFinish, now){
    this.minutesTillBlockingFinish = String(dateBlockingFinish.minute() >= now.minute() ?
      dateBlockingFinish.minute() - now.minute() : 60 - (now.minute() - dateBlockingFinish.minute()));
    this.minutesTillBlockingFinish = Number(this.minutesTillBlockingFinish) >= 1 ? this.minutesTillBlockingFinish : String(1);
  }
}
